export default "__VITE_ASSET__bSKT0zoJ__"